import React, { useEffect, useMemo, useState } from 'react';
import { useSelector } from 'react-redux';
import { useAppDispatch } from '../../../store';
import { TTRestaurantProfile } from '../../../interfaces/restaurant';
import { GuestAddress, TTUserProfile } from '../../../interfaces/user';
import { RootState } from '../../../rootReducer';
import GooglePlacesAutocomplete from 'react-google-places-autocomplete';
import Input from '../../components/Input';
import PillLabel from '../../../components/PillLabel';
import {
  setCateringDetails,
  setFulfillmentDetails,
  setPickUpName,
  setSelectedAddress,
  setTableNumber,
} from '../../../features/cart/cart';
import {
  addNewAddress,
  setFirstName,
  setUserProfile,
} from '../../../features/auth/auth';
import { geocodeByPlaceId } from 'react-google-places-autocomplete';
import { parseGooglePlacesResponse } from '../../../utils/addressParser';
import { guestApi } from '../../../api/guest';
import { message } from 'antd';
import ThemedDatePicker from '../../components/ThemedDatePicker';
import moment from 'moment';
import dayjs, { Dayjs } from 'dayjs';
import {
  OrderFulfillmentCateringDetailsCreate,
  TTOrderFulfillmentCreate,
} from '../../../interfaces/order';
import { CheckCircleIcon } from '@heroicons/react/20/solid';

type Props = {
  restaurant_id: string;
};

type DateProps = {
  restaurant_id: string;
};

export function CateringOrderDetails({ restaurant_id }: Props) {
  const restaurant_profile = useSelector<RootState, TTRestaurantProfile | null>(
    state => state.restaurant.profile,
  );

  const guest = useSelector<RootState, TTUserProfile | null>(
    state => state.auth.userProfile,
  );

  const order_fulfillment = useSelector<
    RootState,
    { [key: string]: TTOrderFulfillmentCreate }
  >(state => state.cart.fulfillment_details ?? {});

  const catering_details = useSelector<
    RootState,
    OrderFulfillmentCateringDetailsCreate | undefined
  >(state => state.cart.catering_details);

  const dispatch = useAppDispatch();
  const [name, setName] = useState('');

  const [presetMode, setPresetMode] = useState<string>('choose');

  const [selectedMode, setSelectedMode] = useState('');
  const [addressValue, setAddressValue] = useState(null);
  const [addingNewAddress, setAddingNewAddress] = useState(true);
  const [comment, setComment] = useState('');
  const selectedAddress = useSelector<RootState, GuestAddress | null>(
    state => state.cart.selected_address,
  );

  useEffect(() => {
    if (restaurant_profile !== null) {
      if (
        restaurant_profile.catering_settings?.offers_delivery &&
        !restaurant_profile.catering_settings?.offers_pickup
      ) {
        setPresetMode('delivery');
        setSelectedMode('delivery');
      } else if (
        !restaurant_profile.catering_settings?.offers_delivery &&
        restaurant_profile.catering_settings?.offers_pickup
      ) {
        setPresetMode('pickup');
        setSelectedMode('pickup');
      }
    }
  }, [restaurant_profile]);

  useEffect(() => {
    if (guest !== null) {
      if (guest?.addresses?.length != 0) {
        setAddingNewAddress(false);
      }
      if (guest?.first_name !== null) {
        setName(guest.first_name);
        dispatch(setTableNumber(`CT_${guest?.first_name?.split(' ')[0]}`));
      }
      if (order_fulfillment[restaurant_id] === undefined) {
        dispatch(
          setFulfillmentDetails({
            [restaurant_id]: {
              guest_id: guest?.id,
              type: 'catering',
              order_item_application: 'all_items',
              catering_details: {
                guest_id: guest?.id,
                schedule_type: 'asap',
                note: '',
              },
            },
          }),
        );
      } else {
        dispatch(
          setFulfillmentDetails({
            [restaurant_id]: {
              ...order_fulfillment[restaurant_id],
              type: 'catering',
              pickup_details: null,
              delivery_details: null,
            },
          }),
        );
      }
      if (catering_details === undefined || catering_details === null) {
        dispatch(
          setCateringDetails({
            [restaurant_id]: {
              guest_id: guest?.id,
              schedule_type: 'scheduled',
            },
          }),
        );
      } else {
        dispatch(
          setFulfillmentDetails({
            [restaurant_id]: {
              ...order_fulfillment[restaurant_id],
              catering_details: { ...catering_details[restaurant_id] },
              pickup_details: null,
              delivery_details: null,
            },
          }),
        );
      }
    }
  }, [guest]);

  return (
    <>
      {restaurant_profile !== null && catering_details && (
        <div className="mx-4 my-2">
          <fieldset>
            {presetMode === 'choose' ? (
              <div>
                <label className=" block uppercase tracking-wide text-on-surface text-sm font-bold pb-2">
                  Select Method
                </label>
                <div className="flex flex-row justify-between items-center px-4 py-2 bg-primary/10 space-x-2 rounded-md">
                  <div
                    className={`flex px-2 py-2 w-1/2 ${
                      selectedMode === 'delivery'
                        ? 'bg-primary border border-primary'
                        : 'bg-surface-variant border border-outline'
                    } rounded-md`}
                    onClick={() => {
                      setSelectedMode('delivery');
                      dispatch(
                        setCateringDetails({
                          [restaurant_id]: {
                            ...catering_details[restaurant_id],
                            is_delivered: true,
                          },
                        }),
                      );
                      dispatch(
                        setFulfillmentDetails({
                          [restaurant_id]: {
                            ...order_fulfillment[restaurant_id],
                            catering_details: {
                              ...catering_details[restaurant_id],
                              is_delivered: true,
                            },
                          },
                        }),
                      );
                    }}
                  >
                    <div
                      className={` ${
                        selectedMode === 'delivery'
                          ? 'text-on-primary'
                          : 'text-on-surface-variant'
                      } text-base  font-semibold`}
                    >
                      Delivery
                    </div>
                  </div>
                  <div
                    className={`flex px-2 py-2 w-1/2  ${
                      selectedMode === 'pickup'
                        ? 'bg-primary border border-primary'
                        : 'bg-surface-variant border border-outline'
                    } rounded-md`}
                    onClick={() => {
                      setSelectedMode('pickup');
                      dispatch(
                        setCateringDetails({
                          [restaurant_id]: {
                            ...catering_details[restaurant_id],
                            is_delivered: false,
                          },
                        }),
                      );
                      dispatch(
                        setFulfillmentDetails({
                          [restaurant_id]: {
                            ...order_fulfillment[restaurant_id],
                            catering_details: {
                              ...catering_details[restaurant_id],
                              is_delivered: false,
                            },
                          },
                        }),
                      );
                    }}
                  >
                    <div
                      className={` ${
                        selectedMode === 'pickup'
                          ? 'text-on-primary'
                          : 'text-on-surface-variant'
                      } text-base  font-semibold`}
                    >
                      Pickup
                    </div>
                  </div>
                </div>
              </div>
            ) : presetMode === 'delivery' ? (
              <div
                className={`flex px-4 py-2 ${
                  selectedMode === 'delivery'
                    ? 'bg-primary border border-primary'
                    : 'bg-surface-variant border border-outline'
                } rounded-md shadow-md`}
                onClick={() => {
                  setSelectedMode('delivery');
                  dispatch(
                    setCateringDetails({
                      [restaurant_id]: {
                        ...catering_details[restaurant_id],
                        is_delivered: true,
                      },
                    }),
                  );
                  dispatch(
                    setFulfillmentDetails({
                      [restaurant_id]: {
                        ...order_fulfillment[restaurant_id],
                        catering_details: {
                          ...catering_details[restaurant_id],
                          is_delivered: true,
                        },
                      },
                    }),
                  );
                }}
              >
                <div className="text-base text-on-primary font-semibold">
                  Delivery
                </div>
              </div>
            ) : (
              <div
                className={`flex px-4 py-2 ${
                  selectedMode === 'delivery'
                    ? 'bg-primary'
                    : 'bg-surface-variant'
                } rounded-md shadow-md`}
                onClick={() => {
                  setSelectedMode('pickup');
                  dispatch(
                    setCateringDetails({
                      [restaurant_id]: {
                        ...catering_details[restaurant_id],
                        is_delivered: false,
                      },
                    }),
                  );
                  dispatch(
                    setFulfillmentDetails({
                      [restaurant_id]: {
                        ...order_fulfillment[restaurant_id],
                        catering_details: {
                          ...catering_details[restaurant_id],
                          is_delivered: false,
                        },
                      },
                    }),
                  );
                }}
              >
                <div className="text-base text-on-primary font-semibold">
                  Pickup
                </div>
              </div>
            )}
          </fieldset>
          <fieldset>
            {restaurant_profile?.catering_settings?.offers_delivery &&
            selectedMode === 'delivery' ? (
              <>
                <div className={'flex flex-col'}>
                  <div className="flex flex-row justify-left content-center items-center mb-2 mt-4">
                    <label className=" block uppercase tracking-wide text-on-surface text-sm font-bold">
                      Full Name
                    </label>
                    <div className="text-gray-900 items-start text-sm text-right -mt-1 ml-2">
                      <PillLabel
                        color="bg-error-container"
                        text_color="text-on-error-container"
                        label="Required"
                      />
                    </div>
                  </div>
                </div>
                <div className="py-2   sm:h-1/5 max-h-1/5 sm:flex rounded bg-surface">
                  <div className="p-4 flex felx-row w-full rounded-lg  justify-between bg-primary/10">
                    <Input
                      // @ts-ignore
                      handleChange={e => {
                        setName(e.target.value);
                      }}
                      handleBlur={async e => {
                        // dispatch(setPickUpName(e.target.value));
                        dispatch(setFirstName(e.target.value?.split(' ')[0]));
                        dispatch(
                          setTableNumber(`CT_${e.target.value?.split(' ')[0]}`),
                        );

                        try {
                          const guestNameResponse = await guestApi.updateGuest(
                            { first_name: e.target.value?.split(' ')[0] },
                            guest?.id,
                          );
                          dispatch(setUserProfile(guestNameResponse.data));
                        } catch (e) {}
                      }}
                      name="name"
                      type="text"
                      value={name}
                      className="appearance-none bg-surface-variant block w-full px-3 py-2 border border-outline-variant rounded-md placeholder-on-surface/60 focus:ring-primary/70 focus:border-primary text-on-surface transition duration-150 ease-in-out text-md sm:leading-5"
                      autoComplete="off"
                      placeholder=""
                    />
                  </div>
                </div>
                <div className="flex flex-row justify-left content-center items-start mb-2 mt-4">
                  <legend className=" block uppercase tracking-wide text-on-surface text-sm font-bold">
                    Delivery Address
                  </legend>
                  <div className="items-start text-sm text-right -mt-1 ml-2">
                    <PillLabel
                      color="bg-error-container"
                      text_color="text-on-error-container"
                      label="Required"
                    />
                  </div>
                </div>
                <div className="bg-primary/10 rounded-md my-2 shadow-md px-4 py-2">
                  {guest !== null && (
                    <div className="mt-1 -space-y-px rounded-md bg-transparent shadow-sm">
                      {addingNewAddress ? (
                        <div className="flex flex-col space-y-4">
                          <label htmlFor="card-number" className="sr-only">
                            Street Address
                          </label>
                          <GooglePlacesAutocomplete
                            apiKey="AIzaSyBCZTG_ZIce0-q8JgRU_EOSpv3vbcFVvwQ"
                            selectProps={
                              {
                                addressValue,
                                onChange: async value => {
                                  const response = await geocodeByPlaceId(
                                    value['value']['place_id'],
                                  );
                                  try {
                                    const addressRequest: GuestAddress = parseGooglePlacesResponse(
                                      response,
                                      guest?.id,
                                    );
                                    const addressSavedResponse = await guestApi.saveAddress(
                                      guest?.id,
                                      addressRequest,
                                    );
                                    dispatch(
                                      setFulfillmentDetails({
                                        [restaurant_id]: {
                                          ...order_fulfillment[restaurant_id],
                                          guest_address_id:
                                            addressSavedResponse.data?.id,
                                        },
                                      }),
                                    );
                                    dispatch(
                                      addNewAddress(addressSavedResponse.data),
                                    );
                                    dispatch(
                                      setSelectedAddress(
                                        addressSavedResponse.data,
                                      ),
                                    );

                                    setAddressValue(value);
                                    setAddingNewAddress(false);
                                  } catch (e) {
                                    message.error('Unable to save address');
                                  }
                                },
                              } as any
                            }
                            onLoadFailed={error =>
                              console.error(
                                'Could not inject Google Maps script',
                                error,
                              )
                            }
                            minLengthAutocomplete={2}
                            autocompletionRequest={{
                              componentRestrictions: { country: 'us' },
                            }}
                          />
                          {guest?.addresses?.length !== 0 && (
                            <div
                              className="flex flex-row bg-secondary text-on-secondary font-semibold rounded-md text-center justify-center py-2"
                              onClick={() => {
                                setAddingNewAddress(false);
                              }}
                            >
                              Cancel
                            </div>
                          )}
                        </div>
                      ) : (
                        <div className="flex flex-col space-y-4">
                          {guest?.addresses?.map(a => {
                            return (
                              <div
                                key={a?.id?.toString()}
                                className={`flex flex-row rounded-md bg-surface items-center px-2 py-2 ${
                                  selectedAddress?.id === a?.id
                                    ? 'border-primary border-2'
                                    : 'border-outline-variant border-2'
                                }`}
                                onClick={() => {
                                  dispatch(setSelectedAddress(a));
                                  dispatch(
                                    setFulfillmentDetails({
                                      [restaurant_id]: {
                                        ...order_fulfillment[restaurant_id],
                                        guest_address_id: a?.id,
                                      },
                                    }),
                                  );
                                }}
                              >
                                {selectedAddress?.id === a?.id && (
                                  <div className="text-primary w-6 mt-1 mr-2">
                                    <CheckCircleIcon color="primary" />
                                  </div>
                                )}
                                <div className=" text-base font-medium text-on-surface mb-0">
                                  <p className="line-clamp-2">
                                    {a?.address_line_1?.concat(
                                      ', ',
                                      a?.city,
                                      ', ',
                                      a?.administrative_area_level_1,
                                      ', ',
                                      a?.country,
                                      ', ',
                                      a?.zip_postal,
                                    )}
                                  </p>
                                </div>
                              </div>
                            );
                          })}
                          <div
                            className="flex flex-row bg-secondary text-on-secondary font-semibold rounded-md text-center justify-center py-2"
                            onClick={() => {
                              setAddingNewAddress(true);
                            }}
                          >
                            Add a new address
                          </div>
                        </div>
                      )}
                    </div>
                  )}
                </div>

                <div className="flex flex-row justify-left content-center items-center mb-2 mt-4">
                  <legend className=" block uppercase tracking-wide text-on-surface text-sm font-bold">
                    Delivery Date & Time
                  </legend>
                  <div className="text-gray-900 items-center text-sm text-right -mt-1 ml-2">
                    <PillLabel
                      color="bg-error-container"
                      text_color="text-on-error-container"
                      label="Required"
                    />
                  </div>
                </div>
                <DatePickerWrapper restaurant_id={restaurant_id} />
                {/* <div className={'h-0.5 w-8/10 bg-gray-900 my-4 mx-auto'} /> */}

                <div className="flex flex-row justify-left content-center items-start mb-2 mt-4">
                  <legend className=" block uppercase tracking-wide text-on-surface text-sm font-bold">
                    Comments
                  </legend>
                </div>
                <div className="mt-1">
                  <textarea
                    rows={2}
                    name="comment"
                    id="comment"
                    onChange={e => {
                      setComment(e?.target?.value);
                      dispatch(
                        setCateringDetails({
                          [restaurant_id]: {
                            ...catering_details[restaurant_id],
                            note: e.target.value,
                          },
                        }),
                      );
                      dispatch(
                        setFulfillmentDetails({
                          [restaurant_id]: {
                            ...order_fulfillment[restaurant_id],
                            catering_details: {
                              ...catering_details[restaurant_id],
                              note: e.target.value,
                            },
                          },
                        }),
                      );
                    }}
                    value={
                      comment?.length !== 0
                        ? comment
                        : catering_details[restaurant_id]?.note ?? ''
                    }
                    className="appearance-none bg-surface-variant block w-full px-3 py-2 border border-outline-variant rounded-md placeholder-on-surface-variant/60 focus:ring-primary/70 focus:border-primary text-on-surface-variant transition duration-150 ease-in-out text-md sm:leading-5"
                  />
                </div>
              </>
            ) : restaurant_profile?.catering_settings?.offers_pickup &&
              selectedMode === 'pickup' ? (
              <>
                <div className={'flex flex-col'}>
                  <div className="flex flex-row justify-left content-center items-center mb-2 mt-4">
                    <label className=" block uppercase tracking-wide text-on-surface text-sm font-bold">
                      Name
                    </label>
                    <div className="text-gray-900 items-start text-sm text-right -mt-1 ml-2">
                      <PillLabel
                        color="bg-error-container"
                        text_color="text-on-error-container"
                        label="Required"
                      />
                    </div>
                  </div>
                </div>
                <div className="py-2   sm:h-1/5 max-h-1/5 sm:flex rounded bg-surface">
                  <div className="p-4 flex felx-row w-full rounded-lg  justify-between bg-primary/10">
                    <Input
                      // @ts-ignore
                      handleChange={e => {
                        setName(e.target.value);
                      }}
                      handleBlur={async e => {
                        dispatch(setFirstName(e.target.value?.split(' ')[0]));
                        dispatch(
                          setTableNumber(`CT_${e.target.value?.split(' ')[0]}`),
                        );

                        try {
                          const guestNameResponse = await guestApi.updateGuest(
                            { first_name: e.target.value?.split(' ')[0] },
                            guest?.id,
                          );
                          dispatch(setUserProfile(guestNameResponse.data));
                        } catch (e) {}
                      }}
                      name="name"
                      type="text"
                      value={name}
                      className="appearance-none bg-surface-variant block w-full px-3 py-2 border border-outline-variant rounded-md placeholder-on-surface/60 focus:ring-primary/70 focus:border-primary text-on-surface transition duration-150 ease-in-out text-md sm:leading-5"
                      autoComplete="off"
                      placeholder=""
                    />
                  </div>
                </div>
                <div className="flex flex-row justify-left content-center items-start mb-2 mt-4">
                  <legend className=" block uppercase tracking-wide text-on-surface text-sm font-bold">
                    Pickup Date & Time
                  </legend>
                  <div className="text-gray-900 items-start text-sm text-right -mt-1 ml-2">
                    <PillLabel color="red" label="Required" />
                  </div>
                </div>
                <DatePickerWrapper restaurant_id={restaurant_id} />

                <div className="flex flex-row justify-left content-center items-start mb-2 mt-4">
                  <legend className=" block uppercase tracking-wide text-on-surface text-sm font-bold">
                    Comments
                  </legend>
                </div>
                <div className="mt-1">
                  <textarea
                    rows={2}
                    name="comment"
                    id="comment"
                    onChange={e => {
                      setComment(e?.target?.value);
                      dispatch(
                        setCateringDetails({
                          [restaurant_id]: {
                            ...catering_details[restaurant_id],
                            note: e.target.value,
                          },
                        }),
                      );
                      dispatch(
                        setFulfillmentDetails({
                          [restaurant_id]: {
                            ...order_fulfillment[restaurant_id],
                            catering_details: {
                              ...catering_details[restaurant_id],
                              note: e.target.value,
                            },
                          },
                        }),
                      );
                    }}
                    value={
                      comment?.length !== 0
                        ? comment
                        : catering_details[restaurant_id]?.note ?? ''
                    }
                    className="appearance-none bg-surface-variant block w-full px-3 py-2 border border-outline-variant rounded-md placeholder-on-surface-variant/60 focus:ring-primary/70 focus:border-primary text-on-surface-variant transition duration-150 ease-in-out text-md sm:leading-5"
                  />
                </div>
              </>
            ) : (
              <></>
            )}
          </fieldset>
        </div>
      )}
    </>
  );
}

function DatePickerWrapper({ restaurant_id }: DateProps) {
  const [deliveryDate, setDeliveryDate] = useState<Dayjs>();

  const catering_details = useSelector<
    RootState,
    OrderFulfillmentCateringDetailsCreate | null
  >(state => state.cart.catering_details ?? {});

  const [deliveryTime, setDeliveryTime] = useState('');
  const dispatch = useAppDispatch();
  useMemo(() => {
    if (deliveryDate && deliveryTime?.length !== 0) {
      const time_moment = moment(deliveryTime, 'HH:mm');
      const combined_moment = deliveryDate
        .hour(time_moment.hour())
        .minute(time_moment.minute())
        .second(time_moment.second());
      dispatch(
        setCateringDetails({
          [restaurant_id]: {
            ...catering_details[restaurant_id],
            scheduled_for: combined_moment.toISOString(),
          },
        }),
      );
    }
  }, [deliveryDate, deliveryTime]);

  return (
    <div className="bg-primary/10 rounded-md my-2 px-4 py-2 flex flex-row items-center justify-between">
      <div>
        <div className="flex flex-row justify-left content-center items-start mb-2">
          <label
            className=" block uppercase tracking-wide text-on-surface text-xs font-bold"
            htmlFor="delivery_date_input"
          >
            Date
          </label>
        </div>
        <ThemedDatePicker
          value={deliveryDate}
          format="MM/DD/YYYY"
          className="w-full"
          inputReadOnly
          id={'delivery_date_input'}
          onChange={date => {
            setDeliveryDate(date ?? undefined);
          }}
          disabledDate={day => {
            const minDate = dayjs();
            const maxDate = dayjs().add(1, 'month').endOf('month');
            return (
              !day.isAfter(minDate, 'day') || !day.isBefore(maxDate, 'day')
            );
          }}
        />
      </div>
      <div className="mb-2">
        <div className="flex flex-row justify-left content-center items-start mb-2">
          <label
            className=" block uppercase tracking-wide text-on-surface text-xs font-bold"
            htmlFor="delivery_time_input"
          >
            Time
          </label>
        </div>
        <input
          type="time"
          id="delivery_time_input"
          name="delivery_time_input"
          min="09:00"
          max="21:00"
          step="900"
          required
          onChange={e => {
            e.preventDefault();
            setDeliveryTime(e.target.value);
          }}
          value={deliveryTime}
          className="block w-full rounded-md border-1.5 border-outline shadow-sm focus:border-primary focus:ring-0 sm:text-base text-on-surface-variant bg-surface-variant"
        />
      </div>
    </div>
  );
}
